import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import EmptyStateTalentIcon from '@components/Icon/EmptyStateTalent';

const StyledContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 300,
    padding: theme.spacing(4),
    textAlign: 'center',
    width: '100%',
    height: '100%',
}));

export interface EmptyStateProps {
    title?: string;
    subtitle?: string;
    /** @deprecated Use subtitle instead */
    description?: string;
    icon?: React.ReactNode;
    actionLabel?: string;
    onAction?: () => void;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    title,
    subtitle,
    description,
    icon,
    actionLabel,
    onAction,
}) => {
    const theme = useTheme();
    const subtitleText = subtitle ?? description;

    return (
        <StyledContainer>
            {icon !== undefined ? icon : <EmptyStateTalentIcon style={{ marginBottom: '23.5px' }} />}
            {title && (
                <Typography
                    fontSize="20px"
                    fontWeight={600}
                    fontFamily="Lemon milk pro"
                    marginBottom="8px"
                    color={theme.palette.mode === 'dark' ? theme.palette.text.secondary : theme.palette.text.primary}>
                    {title}
                </Typography>
            )}
            {subtitleText && (
                <Typography
                    fontSize="16px"
                    fontWeight={400}
                    lineHeight="22.72px"
                    color={theme.palette.neutralLightGrey.main}>
                    {subtitleText}
                </Typography>
            )}
            {actionLabel && onAction && (
                <Button
                    variant="contained"
                    onClick={onAction}
                    sx={{ mt: 3 }}>
                    {actionLabel}
                </Button>
            )}
        </StyledContainer>
    );
};

export default EmptyState;
